import * as React from "react";
import { Box, Fade } from "@mui/material";

export default function BackgroundSlideshow({ images, interval = 5000 }) {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % images.length), interval);
    return () => clearInterval(id);
  }, [images.length, interval]);

  return (
    <>
      {images.map((bg, i) => (
        <Fade in={i === index} timeout={1500} key={bg}>
          <Box
            sx={{
              backgroundImage: `linear-gradient(rgba(0,0,0,.08), rgba(0,0,0,.18)), url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              inset: 0,
              zIndex: -2,
            }}
          />
        </Fade>
      ))}
      <Box sx={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.03)", zIndex: -1 }} />
    </>
  );
}
